// Dependencies
import React from 'react';
import radium from 'radium';
import Moment from "react-moment";
import 'moment/locale/de';
import {ThemeContext} from "../../../components/theme/Theme.jsx";

function EventData(props) {

	const context = React.useContext(ThemeContext);
	const style = {
		container: {
			display: 'flex',
			alignItems: 'baseline',
			justifyContent: 'space-between',
			flexWrap: 'wrap'
		},
		title: {
			fontWeight: '800',
			width: '100%',
			marginRight: '.5em'
		},
		subtitle: {
			fontSize: '.9em'
		},
		dateLocation: {
			color: context.themeManager.value('shopping-cart-event-time-location', 'color', 'fg-color-text'),
			fontSize: context.themeManager.value('shopping-cart-event-time-location', 'fontSize', 'font-size-90'),
			margin: '.4em 0 .1em',
		}
	};

	return (
		<div style={style.container}>
			<div>
				<span style={style.title}>{props.title}</span>
				{props.subtitle &&
					<span style={style.subtitle}> ({props.subtitle}) </span>
				}
			</div>

			<div style={style.dateLocation}>
				<span><Moment locale="de" format="DD.MM.YYYY HH:mm">{props.date}</Moment></span>, <span>{props.location}</span>
			</div>
		</div>
	);
}

export default radium(EventData);
